import { render } from "./CreatePartnerModal.vue?vue&type=template&id=124cce3d"
import script from "./CreatePartnerModal.vue?vue&type=script&lang=js"
export * from "./CreatePartnerModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__